/// <amd-module name="Dashboards/DashboardPanel/Common" />
import { IIdentity } from "VSSUI/IdentityPicker";

export const Constants = Object.freeze({
    maxNameLength: 32,
    maxDescriptionLength: 128,
    autoRefreshIntervalInMins: 5
});

export interface FormFields {
    name: string;
    description: string;
    teamId: string | undefined;
    projectId: string | undefined;
    owner: IIdentity | undefined;
    autoRefresh: boolean;
    copyQueriesFlag: boolean;
    queryFolderPath: string;
}

export interface Group {
    id:string;
    name: string
}

export interface Project extends Group{
}

export interface Team extends Group {
}

export interface TeamProjectItem {
    project: Project;
    teamList: Team[];
}

export enum DashboardType {
    Project = "project",
    Team = "team"
}

export interface NewDashboardItem {
    id: string;
    teamId: string;
    projectId: string;
}

export interface TeamProjectListItem {
    id: string;
    name: string;
    projectId: string;
    projectName: string;
}

export const WebAccessDashboardsSecurityDialog = "WebAccess.Dashboards.SecurityDialog";
export const SecurityNameSpaceIdForDashboards = "8ADF73B7-389A-4276-B638-FE1653F7EFC7";
